module.exports = __webpack_public_path__ + "img/phone-numbers.svg";